//FINAL BUT NEED SIMPLFICATIONS
define('SageDotCom/Components/Forms/GatedContentTester',["SageDotCom/Utility/gatedContentHelper"], (gatedContentHelper) => {
    function GatedContentTester(scope) {
        if (!scope.querySelector(".gatedContentTester")) {
            return;
        }
        const GATEDID_EXACT_NB_CHAR = 41;
        const openModalButtonQuery = ".openModalButton";
        const formContainerQuery = ".gatedFormIdToLoad";
        const formContainerLoadedQuery = "[class^='gate-']";

        const inputGatedFormId = scope.querySelector(".gatedFormId");
        const loadButton = scope.querySelector(".loadButton");
        const openModalButton = scope.querySelector(openModalButtonQuery);
        const copyUrlButton = scope.querySelector(".copyUrlButton");
        const resetButton = scope.querySelector(".resetButton");
        const formContainer = scope.querySelector(formContainerQuery);
        const errorMessage = scope.querySelector(".errorMessage");
        //check all component's elements presence
        if (!inputGatedFormId || !loadButton || !openModalButton || !copyUrlButton || !formContainer || !errorMessage || !resetButton) {
            return;
        }
        const hideConditionalButtons = (yes) => {
            const currentOpenModalButtonQuery = scope.querySelector(openModalButtonQuery);
            if (currentOpenModalButtonQuery) {
                currentOpenModalButtonQuery.style.display = yes ? "none" : "block";
            }
            copyUrlButton.style.display = yes ? "none" : "block";
        };

        const defaultPageURL = `${window.location.origin}${window.location.pathname}`;

        //XSS input sanitizations
        inputGatedFormId.addEventListener("input", () => {
            inputGatedFormId.value = inputGatedFormId.value.replace(/[^a-z0-9\-]/gi, "").slice(0, GATEDID_EXACT_NB_CHAR);
            errorMessage.innerHTML = "";
        });
        const isValidGatedId = (value) => /^gate-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(value);

        const gatedFormId = (() => {
            const id = new URLSearchParams(window.location.search).get("gate");
            return (id && isValidGatedId(id)) ? id.trim().toLowerCase() : null;
        })();

        if (gatedFormId) {
            inputGatedFormId.value = gatedFormId;
            formContainer.className = ""; //we need to have only 1 class in it to allow gated Algo to generate the form content
            formContainer.classList.add(`gate-${gatedFormId.replace("gate-", "")}`); //CSS sanitization
            copyUrlButton.setAttribute("data-sharelink", window.location.href);
        } else {
            hideConditionalButtons(true);
        }

        let resetClicked = false;

        const reloadGatedFormInPage = (scopeArea) => {
            gatedContentHelper.unLoadGatedContent(scopeArea);
            gatedContentHelper.loadGatedContent(scopeArea);
        };

        const removeAllAttributesExceptClass = (element) => {
            [...element.attributes].forEach(attr => {
                if (attr.name !== "class") {
                    element.removeAttribute(attr.name);
                }
            });
        };

        const resolveAndUpdateFormContainer = (gatedId, containerSelector, fallbackSelector) => {
            let container = scope.querySelector(containerSelector) || scope.querySelector(fallbackSelector);
            if (container) {
                removeAllAttributesExceptClass(container); //removal need for the gated algo to run correctly
                container.className = "";
                container.classList.add(`gate-${gatedId.replace("gate-", "")}`);
            }
            return container;
        };

        loadButton.addEventListener("click", () => {
            const actualGatedFormId = inputGatedFormId.value.trim();
            if (!isValidGatedId(actualGatedFormId)) {
                errorMessage.textContent = "❌ Gated Form ID empty or invalid format";
                return;
            }
            if (resetClicked || actualGatedFormId !== gatedFormId) {
                const updatedURL = `${defaultPageURL}?gate=${encodeURIComponent(actualGatedFormId)}`;
                const updatedOpenModalButton = scope.querySelector(openModalButtonQuery);
                if (updatedOpenModalButton) {
                    updatedOpenModalButton.setAttribute("href", `#${actualGatedFormId}`); //attribute needed by the gated logic to generate the modal
                }
                copyUrlButton.setAttribute("data-sharelink", updatedURL);
                const updatedFormContainer = resolveAndUpdateFormContainer(actualGatedFormId, formContainerQuery, formContainerLoadedQuery);
                if (updatedFormContainer) {
                    updatedFormContainer.className = ""; //we need to have only 1 class in it to allow gated Algo to generate the form content
                    updatedFormContainer.classList.add(`gate-${actualGatedFormId.replace("gate-", "")}`); //CSS sanitization
                }
                const browserUrl = new URL(window.location.href);
                browserUrl.searchParams.set("gate", actualGatedFormId); //set or update the url parameters
                history.pushState(null, "", browserUrl.toString());
                resetClicked = false;
                hideConditionalButtons(false);
                reloadGatedFormInPage(scope);
            }
        });

        copyUrlButton.addEventListener("click", (event) => {
            const originalText = event.target.textContent;
            const shareLink = copyUrlButton.getAttribute("data-sharelink");
            if (shareLink) {
                navigator.clipboard.writeText(shareLink)
                    .then(() => {
                        event.target.textContent = "✅ URL copied"; 
                        //reshow the copy label
                        setTimeout(() => {
                            event.target.textContent = originalText;
                        }, 2000);
                    })
                    .catch(() => {
                        console.error("⚠️ URL copy not allowed"); 

                    });
            } else {
                console.warn("data-sharelink attribute is missing");
            }
        });

        resetButton.addEventListener("click", () => {
            resetClicked = true;
            inputGatedFormId.value = "";
            errorMessage.innerHTML = "";
            history.pushState(null, "", defaultPageURL);
            const actualFormContainer = scope.querySelector(formContainerLoadedQuery);
            if (actualFormContainer) {
                actualFormContainer.innerHTML = "";
            }
            hideConditionalButtons(true);
        });

        if (gatedFormId) {
            openModalButton.setAttribute("href", `#${gatedFormId}`); //attribute needed by the gated logic to generate the modal
            reloadGatedFormInPage(scope);
        }
    }

    GatedContentTester.init = (args) => {
        return args.isExperienceEditor === true
            ? null
            : new GatedContentTester(args.scope);
    };

    return GatedContentTester;
});

